import { render, staticRenderFns } from "./PaymentStatusView.vue?vue&type=template&id=d0a34da6"
import script from "./PaymentStatusView.vue?vue&type=script&lang=js"
export * from "./PaymentStatusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports